import React from 'react'
import { useOutletContext } from 'react-router-dom'

import type { ClientLibraryId } from 'types/client-library'

import LibrariesLibraryAlbumsAdd from 'pages/libraries/library/albums/add'
import LibrariesLibraryAlbumsAlbum from 'pages/libraries/library/albums/album'
import LibrariesLibraryPlaylistsAdd from 'pages/libraries/library/playlists/add'
import LibrariesLibraryPlaylistsPlaylist from 'pages/libraries/library/playlists/playlist'

export type ArtistProfileOutletContext = {
  libraryId: ClientLibraryId
}

/**
 * Modal for publishing releases to the artist profile, at `/artist-profile/releases/add`.
 */
export const ArtistProfileReleasesAdd = () => {
  const { libraryId } = useOutletContext<ArtistProfileOutletContext>()

  return <LibrariesLibraryAlbumsAdd libraryId={libraryId} variant="releases" />
}

/**
 * Modal for editing a release's cover design and release date, at `/artist-profile/releases/:playlistId`.
 */
export const ArtistProfileRelease = () => (
  <LibrariesLibraryAlbumsAlbum variant="releases" />
)

/**
 * Modal for publishing playlists to the artist profile, at `/artist-profile/playlists/add`.
 */
export const ArtistProfilePlaylistsAdd = () => {
  const { libraryId } = useOutletContext<ArtistProfileOutletContext>()

  return <LibrariesLibraryPlaylistsAdd libraryId={libraryId} />
}

/**
 * Modal for editing a playlist's cover design, at `/artist-profile/playlists/:playlistId`.
 */
export const ArtistProfilePlaylist = () => (
  <LibrariesLibraryPlaylistsPlaylist backPath="/artist-profile" />
)
